import React, { useRef, useEffect } from "react";
import { IoIosArrowDown } from "react-icons/io";
import useStateRef from "react-usestateref";
import styles from "../../../styles/dropdown.module.css";
import { isEmptyOrNull } from "../../../utils/common-utils";

export default function Dropdown({
  value = "",
  setValue,
  data,
  placeholder,
  isDisable = false
}) {
  const [showMenu, setShowMenu, showMenuRef] = useStateRef(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setShowMenu((prev) => !prev);
  const closeDropdown = () => setShowMenu(false);

  useEffect(() => {
    function handleOutsideClick(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const getDropdownLabel = (value) => {
    let res = data?.find((item) => (item?.value || item) === value);
    return res?.label || res || "";
  };

  const getLabelName = (key) => {
    if (key == "Ai Tutor related") {
      key = "Quality of Conversation";
    } else if (key == "Content related") {
      key = "Quality of Content";
    }
    return key;
  };
  let dropdownBtnStyle = `${styles["dropdown-btn"]} ${
  isDisable ? styles["disable-dropdown"] : ""}`;

  let iconStyle = `${styles["arrow"]} ${showMenu ? styles["up"] : ""} ${
  isDisable ? styles["disable-dropdown"] : ""}`;

  let dropdownContainerStyle = `${styles["dropdown-content"]} ${
  showMenuRef?.current ? styles["show"] : ""}`;


  return (
    <div className={styles["dropdown"]} ref={dropdownRef}>
      <div
        className={dropdownBtnStyle}
        onClick={() => {
          !isDisable && toggleDropdown();
        }}>

        <div
          className={
          isEmptyOrNull(value) ? undefined : styles["selected-value"]
          }>

          {value === "" ? placeholder : getLabelName(getDropdownLabel(value))}
        </div>
        <IoIosArrowDown className={iconStyle} />
      </div>
      <div className={dropdownContainerStyle}>
        {data?.map((item, index) => {
          let itemStyle = `${styles["dropdown-item"]} ${
          value === (item?.value || item) ? styles["selected"] : undefined}`;

          return (
            <div
              className={itemStyle}
              key={index}
              onClick={() => {
                setValue(item?.value || item);
                closeDropdown();
              }}>

              {getLabelName(item?.label || item)}
            </div>);

        })}
      </div>
    </div>);

}